import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// Finance Refunds tab — GET /api/payment/getAllRefunds, extended (§5.5 directive; the
// endpoint already existed in pillengine as an unused hook, see
// src/hooks/fetch-hooks/get-all-refunds). Row entity is `refunds`; Order ID/Quotation ID/
// Partner/Partner Entity ID are already comma-joined, deduplicated and sorted server-side
// (classes/Refund/Functions.js) — this hook does no further shaping.
//
// Response shape is `{ refunds, total, page, size }`, NOT `{ count, rows }` like the
// other three finance endpoints — controller/refund.js:getAllRefunds names it
// differently; kept as-is rather than normalized on the backend to avoid touching an
// endpoint other consumers may already read.
export default function useFinanceRefunds({ page = 1, size = 20, enabled = true } = {}) {
    const params = { page, size };

    return useQuery(
        ["finance-refunds", params],
        async () => {
            const result = await request({ url: "payment/getAllRefunds", method: "GET", params });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;

            const { refunds, total } = body.data;
            return {
                refunds: refunds || [],
                pagination: { page, size, total: Number(total) || 0 },
            };
        },
        { keepPreviousData: true, retry: false, enabled }
    );
}
